<template>
  <div class="aboutUs">
    <div class="introduce">
      <h1>{{ introduceData.title }}</h1>
      <div v-html="introduceData.content" />
    </div>
    <div class="leader">
      <h1>领导团队</h1>
      <div v-for="item in leaderData" :key="item.id">
        <div class="image" style="position: relative;">
          <img :src="item.picUrl" alt="">
          <div class="info">
            <p>{{ item.name }}</p>
            <span class="line" />
            <p class="position">{{ item.port }}</p>
          </div>
        </div>
        <div>
          <p class="leader-introduce">{{ item.introduction }}</p>
        </div>
        <br style="clear:both">
      </div>
    </div>
    <div class="history">
      <h1>荣誉及里程碑</h1>
      <div v-html="historyData.content" />
    </div>
    <div class="culture">
      <h1>{{ cultureData.title }}</h1>
      <div v-html="cultureData.content" />
    </div>
    <div class="culture-news">
      <div v-for="item in cultureNewsData" :key="item.id" class="item" @click="linkTo(item)">
        <img :src="item.picUrl" alt="">
        <p>{{ item.title }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getWebsiteMilepostInfo, getWebsiteLeaderInfoList } from '@/apis/aboutUs'
import { getNewsList } from '@/apis/index'
export default {
  data() {
    return {
      introduceData: {},
      leaderData: [],
      historyData: {},
      cultureData: {},
      cultureNewsData: []
    }
  },
  created() {
    this.getIntroduceData()
    this.getLeaderData()
    this.getHistoryData()
    this.getCultureData()
    this.getCultureNewsData()
  },
  methods: {
    // 公司简介
    getIntroduceData() {
      const data = {
        type: 2
      }
      getWebsiteMilepostInfo(data).then(res => {
        this.introduceData = res
      }).catch(err => {
        this.$message.error(err)
      })
    },
    // 领导团队
    getLeaderData() {
      getWebsiteLeaderInfoList().then(res => {
        res.map(item => {
          item.picUrl = 'https://static.htd.cn/' + item.picUrl
        })
        this.leaderData = res
      }).catch(err => {
        this.$message.error(err)
      })
    },
    // 历史及里程碑
    getHistoryData() {
      const data = {
        type: 1
      }
      getWebsiteMilepostInfo(data).then(res => {
        this.historyData = res
      }).catch(err => {
        this.$message.error(err)
      })
    },
    // 企业文化
    getCultureData() {
      const data = {
        type: 3
      }
      getWebsiteMilepostInfo(data).then(res => {
        this.cultureData = res
      }).catch(err => {
        this.$message.error(err)
      })
    },
    // 企业文化新闻
    getCultureNewsData() {
      const data = {
        type: 2,
        page: 1,
        rows: 10
      }
      getNewsList(data).then(res => {
        res.map(item => {
          item.picUrl = 'https://static.htd.cn/' + item.picUrl
        })
        this.cultureNewsData = res.slice(0, 6)
      }).catch(err => {
        this.$message.error(err)
      })
    },
    linkTo(item) {
      this.$router.push({
        path: '/newsDetail',
        query: {
          source: '关于我们',
          id: item.id
        }
      })
    }
  }
}
</script>

<style lang="less">
.aboutUs{
    padding: 0 19px;
    .introduce{
      padding-bottom: 20px;
      border-bottom: 1px solid rgb(238 238 238 / 50%);
      h1{
        font-size: 24px;
        line-height: 26px;
        font-weight: 600;
        margin: 80px 0 20px;
      }
      p{
        margin-bottom: 20px;
        font-size: 16px;
        line-height: 27px;
        text-align: left;
        text-indent: 32px;
      }
      div p:nth-child(2n){
        display: none;
      }
      span{
        font-size: 14px !important;
      }
    }
    .leader{
      padding-bottom: 20px;
      width: 100%;
      border-bottom: 1px solid rgb(238 238 238 / 50%);
      h1{
        font-size: 24px;
        line-height: 26px;
        font-weight: 600;
        margin: 30px auto 20px;
      }
      img{
        width: 100%;
        border-radius: 4px;
      }
      .info{
        padding-top: 28px;
        width: 70px;
        height: 85px;
        background: #242154;
        position: absolute;
        left: 0;
        bottom: -60px;
        font-size: 0;
        box-sizing: border-box;
        p{
          line-height: 18px;
          font-size: 17px;
          margin: 0;
          color: #FFFFFF;
          font-weight: bold;
        }
        .position{
          font-size: 14px;
          line-height: 14px;
          color: rgba(255, 255, 255, .5);
        }
        span{
          display: inline-block;
          width: 50px;
          height: 1px;
          margin: 7px 0;
          background: rgba(255, 255, 255, .5);
        }
      }
      .leader-introduce{
        margin-bottom: 25px;
        padding: 10px 0 0 13px;
        max-width: calc(100% - 70px);
        float: right;
        text-align: left;
        font-size: 14px;
        line-height: 20px;
      }
    }
    .history{
      padding-bottom: 40px;
      width: 100%;
      border-bottom: 1px solid rgb(238 238 238 / 50%);
      h1{
        font-size: 24px;
        line-height: 26px;
        font-weight: 600;
        margin: 30px auto 20px;
      }
      div {
        p{
          margin: 0;
          font-size: 16px !important;
          text-align: left;
          line-height: 27px;
          color: #2C3E50;
        }
        span{
          display: inline-block;
          font-size: 14px !important;
          text-align: left;
        }
      }
    }
    .culture{
      width: 100%;
      h1{
        font-size: 24px;
        line-height: 26px;
        font-weight: 600;
        margin: 30px auto 20px;
      }
      div {
        p{
          font-size: 16px !important;
          margin: 0;
          text-align: left;
          line-height: 27px;
        }
        span{
          display: inline-block;
          margin-bottom: 5px;
          font-size: 14px !important;
          text-align: left;
        }
      }
      div span:nth-child(6){
        display: none;
      }
    }
    .culture-news{
      margin: 30px 0;
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item{
        width: 100%;
        img{
          width: 100%;
          border-radius: 4px;
        }
        p{
          margin: 8px 0 20px;
          text-align: left;
          font-size: 14px;
        }
      }
    }
}
</style>
